export const ACCOUNT_NOT_VERIFIED = 'ACCOUNT_NOT_VERIFIED';
export const NOT_IN_ENROLLMENT_PERIOD = 'NOT_IN_ENROLLMENT_PERIOD';
